/* eslint-disable no-shadow */

import { SelectedAgentsQuery } from '@/graphql/codegen/generated/graphql';

/* eslint-disable no-unused-vars */
export enum BuildPriorityEnums {
  HighBuildPriority = 'HighBuildPriority',
  AboveNormalBuildPriority = 'AboveNormalBuildPriority',
  NormalBuildPriority = 'NormalBuildPriority',
  BelowNormalBuildPriority = 'BelowNormalBuildPriority',
  LowBuildPriority = 'LowBuildPriority',
}

export enum LogLevelEnums {
  Minimal = 'Minimal',
  Basic = 'Basic',
  Intermediate = 'Intermediate',
  Extended = 'Extended',
  Detailed = 'Detailed',
}

export enum RegistryKeyEnums {
  CoordHost = 0,
  CoordPort = 1,
  MaxLogSize = 2,
  OnlyFailLocally = 3,
  UseMsBuild = 4,
  Use64bitToolset = 5,
  ForceCPUCount_WhenInitiator = 6,
  ForceCPUCount_WhenHelper = 7,
  HelperActivityReportTimeout = 8,
  MultiThreadedFileSyncThreads = 9,
  ForceEnglishMSBuildOutput = 10,
  AllowParallelLink = 11,
  MaxParallelLinkTargets = 12,
  AvoidLocalExec = 13,
  MaxConcurrentPDBs = 14,
  PredictedExecutionMode = 15,
  BuildMonitorOutputFont = 16,
}

export type SelectedAgent = NonNullable<NonNullable<NonNullable<SelectedAgentsQuery['agents']>['agents']>[number]>;
